export default __webpack_public_path__ + "static/media/Eye.653c7097.svg";